import { CircularProgress } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dispatch, useSelector } from 'store';
import { openAlert } from 'store/slices/notification';
import { onFetchSimulations, onAcceptSimulation, onOpenAcceptAlert } from 'store/slices/simulation';
import { openSnackbar } from 'store/slices/snackbar';

import AlertDialog from 'ui-component/dialogs/AlertDialog';

const AcceptSimulationAlert: FC = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const { openAccept, simulationId } = useSelector((state) => state.simulation);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleUndo = () => {
        dispatch(onOpenAcceptAlert(!openAccept));
    };

    const handleAccept = async () => {
        if (!user || !simulationId) return false;

        setIsLoading(true);
        try {
            const res = await dispatch(onAcceptSimulation(user.tenantId, user.userId, user.userName, simulationId));
            if (res) {
                dispatch(onOpenAcceptAlert(false));
                dispatch(openAlert(true));
                dispatch(onFetchSimulations(user.tenantId));
                dispatch(
                    openSnackbar({
                        open: true,
                        message: t('SIMULATION_ACCEPT_SUCCESSFULLY'),
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: false
                    })
                );
            } else {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: t('SIMULATION_ACCEPT_FAILED'),
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: false
                    })
                );
            }
            setIsLoading(false);
            return res;
        } catch (error) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: t('SIMULATION_ACCEPT_FAILED'),
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            setIsLoading(false);
            return false;
        }
    };

    return (
        <AlertDialog
            open={openAccept}
            dialogTitle="Sei sicuro di voler procedere?"
            content="Attenzione! Accettando la simulazione renderai effettive tutte le modifiche della simulazione attuale e questa verrà cancellata e non si potrà più tornare indietro. Assicurati di aver valutato attentamente le conseguenze prima di procedere."
            onAccept={handleAccept}
            onCancel={handleUndo}
            onClose={handleUndo}
            cancelButtonProps={{ children: 'Annulla' }}
            acceptButtonProps={{
                children: isLoading ? (
                    <CircularProgress color="inherit" sx={{ width: '20px !important', height: '20px !important' }} />
                ) : (
                    'Accetta simulazione'
                ),
                variant: 'contained'
            }}
        />
    );
};

export default AcceptSimulationAlert;
